export interface CreatePhoneCallRequest {
  from_number: string;
  to_number: string;
  override_agent_id: string;
  metadata?: {
    customer_name?: string;
    customer_phone?: string;
    widget_type?: string;
    origin?: string;
    timestamp?: string;
    [key: string]: any;
  };
  retell_llm_dynamic_variables?: {
    [key: string]: string;
  };
}

export interface CreatePhoneCallResponse {
  call_id: string;
  call_status: string;
  from_number: string;
  to_number: string;
  created_at: string;
}

export class RetellApiService {
  private baseUrl = 'https://api.retellai.com/v2';

  async createPhoneCall(
    request: CreatePhoneCallRequest,
    publicKey: string,
  ): Promise<CreatePhoneCallResponse> {
    const response = await fetch(`${this.baseUrl}/create-phone-call`, {
      method: 'POST',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${publicKey}`,
        Origin: window.location.origin,
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Failed to create phone call: ${response.status} ${response.statusText}. ${errorData.message || ''}`,
      );
    }

    return response.json();
  }
}

export const retellApiService = new RetellApiService();
